import { render } from "./UserInfo.vue?vue&type=template&id=bcb839d2&scoped=true&ts=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=bcb839d2&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb839d2"]])

export default __exports__